<template>
  <div>
    <div class="title">航空综合险</div>
    <el-divider id="bottom-divider"></el-divider>
    <table border="1" cellspacing="0" cellpadding="0">
      <tr class="tr1" style="height: 30px ">
        <th style="width: 160px">产品名称</th>
        <th style="width: 160px">承保公司</th>
        <th style="width: 240px">保障范围</th>
        <th style="width: 360px">赔偿限额</th>
        <th style="width: 160px">保险期限</th>
      </tr>
      <tr>
        <td rowspan="7">航空综合险</td>
        <td rowspan="7">宇宙永不破产保险股份有限公司</td>
        <td>航空意外身故、残疾</td>
        <td>2,000,000元</td>
        <td rowspan="7">约定航班</td>
      </tr>
      <tr>
        <td>航空意外伤害医疗</td>
        <td>100,000元</td>
      </tr>
      <tr>
        <td>航班延误</td>
        <td>
          <span style="color: red">乘坐约定航班起飞延误</span
          >3小时及以上赔偿300元，最高赔偿300元
        </td>
      </tr>
      <tr>
        <td>托运行李延误</td>
        <td>6小时及以上赔偿1,000元，最高赔偿1,000元</td>
      </tr>
      <tr>
        <td>托运行李损失</td>
        <td>600元</td>
      </tr>
      <tr>
        <td>航班当天取消</td>
        <td>一次性赔偿100元</td>
      </tr>
      <tr>
        <td>证件遗失</td>
        <td>1000元</td>
      </tr>
      <tr style="height: 50px">
        <td colspan="5">航空综合险保险费：30元/份.航班</td>
      </tr>
    </table>
  </div>
</template>
<style lang="scss" scoped>
@import '@/assets/css/config.scss';
.title {
  margin-top: 10%;
  line-height: 30px;
  font-weight: 600;
  font-size: 20px;
  color: $themeLight;
}
#bottom-divider {
  margin-top: 30px;
  height: 0.07px;
  line-height: 0.07px;
}
table {
  border-color: $themeLightGray;
  font-size: 14px;
}
tr {
  line-height: 30px;
}
td {
  padding: 5px 0;
  font-size: 12px;
}
</style>
